"use strict";

/**
* Диалоговое окно.
*
* @class WebAccess.components.dialogs.BaseDialog
* @since 5.0.0.4000
* @extends BaseObject
*
* @property {string} id ИД диалогового окна
* @property {string} name Номер набора данных
* @property {string} title Заголовок модального диалога
* @property {string} html Содержимое окна
* @property {string} okText Подпись кнопки «OK»
* @property {string} cancelText Подпись кнопки «Отмена»
* @property {function} ok  Функция обратного вызова, исполняется при нажатии на кнопку «OK»
* @property {function} cancel  Функция обратного вызова, исполняется при нажатии на кнопку «Отмена»
* @property {integer} height Высота модального диалога
* @property {integer} width Ширина модального диалога
* @property {boolean} resizable Возможность изменения размеров окна
* @property {boolean} modal Если значение равно False, то задний план затемняется
* @property {boolean} enterOk Если значение равно True, при нажатии на ENTER срабатывает нажатие на кнопку «OK»
* @property {boolean} isShowOkButton Отображать кнопку «ОК»
* @property {boolean} isShowCancelButton Отображать кнопку «Отмена»
* @property {boolean} isOpened Признак того, что окно уже открылось
* @property {boolean} isSingleme Не открывать новое окно, если такое же окно открыто. Значение по умолчанию TRUE
* @property {string} dialogClass Указанное имя класса будет добавлено к диалогу
* @property {WebAccess.components.notifications.inlineHint} inlineHint Сообщение об ошибке, отображаемое на странице @since 5.0.0.7400
*
* @example
* var dialog = new WebAccess.components.dialogs.BaseDialog();
*     dialog.setHtml("TestHTML");
*     dialog.show();
*
* @example <caption>Создание собственных кнопок</caption>
* var dialog = new WebAccess.components.dialogs.BaseDialog();
* var myButton = { id: "myButtonID", text: "Button", click: myFunction };
*     dialog.modalWindowButtons.push(myButton);
*     dialog.show();
*
* @example <caption>Отображение сообщения об ошибке</caption>
* var dialog = new WebAccess.components.dialogs.BaseDialog();
*     dialog.show();
*     dialog.inlineHint.showError('Этот диалог пока бесполезен');
*/
(function (global) {

  var BaseDialog = BaseObject.extend({
    init: function (settings) {
      var me = this;
      this.modalWindowButtons = [];
      this.id = new Date().getTime(); //timestamp
      this._super(settings);

      this._setKeyBindings();

      if ($.isPlainObject(settings)) {
        $.extend(this, settings);
      }

      var me = this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    className: 'BaseDialog',
    dialogClass: '',
    inlineHint: null,
    id: "0",
    modalWindowButtons: [],
    title: L("MODAL_DIALOG"),
    html: L("MODAL_DIALOG_INITIAL_TEXT"),
    okText: L("OK"),
    cancelText: L("CANCEL"),
    closeText: L("CLOSE"),
    ok: function () { },
    cancel: function () { },
    height: 'auto',
    width: 'auto',
    minWidth: 350,
    resizable: false,
    modal: true,
    enterOk: true,
    onOpen: function () { },
    onClose: function () { },
    isShowOkButton: true,
    isShowCancelButton: false,
    closeOnEscape: true,
    keyScope: 'baseDialog',
    isSingleme: true,
    keyBindings: {},
    _jContent: null,
    _isFitted: false,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Задает сочетания глобальных горячих клавишь.
     * @private
     */
    _setKeyBindings: function () {
      var me = this;
      me.keyBindings = {
        "enter": function (e) {
          if (e && $(e.target).is('.ui-dialog-titlebar-close')) return;
          $("#modal_ok_button_" + me.id).click();
        }
      };
    },

    /**
    * Показывает иконку прогресса при выполнении длительной операции.
    *
    * @function WebAccess.components.dialogs.BaseDialog#setSpinner
    * @param {String} [opt_text] текст диалога
    * @since 5.0.0.7100
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    */
    setSpinner: function (opt_text) {
      this.setTitle(L('PLEASE_WAIT'));

      var spinnerHtml = '<div class="circle-spinner {0}"></div>{1}';

      if (opt_text)
        spinnerHtml = format(spinnerHtml, "ui-dialog__spinner_right", opt_text);
      else
        spinnerHtml = format(spinnerHtml, "ui-dialog__spinner_centered", "");

      this.setHtml(spinnerHtml);

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Удаляет кнопки «ОК» и «Отмена» с формы диалогового окна.
    *
    * @method WebAccess.components.dialogs.BaseDialog#removeDefaultButtons
    * @since 5.0.0.7200
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    */
    removeDefaultButtons: function () {
      this.isShowOkButton = false;
      this.isShowCancelButton = false;
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрывает кнопку закрытия диалога.
    * @method  WebAccess.components.dialogs.BaseDialog#removeCloseButton
    * @since 5.2.0.1931
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    */
    removeCloseButton: function () {
      if (this.isOpened())
        $('#dialog_content_' + this.id).parent().parent().find(".ui-dialog-titlebar-close").remove();
      else
        this.bind(this['class'].EVENT.AFTER_OPEN, this.removeCloseButton);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Включает отображение кнопки "Отмена".
    * @method  WebAccess.components.dialogs.BaseDialog#showCancelButton
    * @since 5.2.0.1300
    * @todo: Реализовать до конца
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    */
    showCancelButton: function () {
      this.isShowCancelButton = true;
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Задает ширину окна.
    * @method  WebAccess.components.dialogs.BaseDialog#setWidth
    * @param {integer} width Ширина в пикселях
    * @since 5.2.0.1300
    * @todo: Реализовать до конца
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    */
    setWidth: function (width) {
      var me = this;
      me.width = width;
      if (me._jContent) {
        me._jContent.dialog("option", "width", width);
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Задает высоту окна.
    * @method  WebAccess.components.dialogs.BaseDialog#setWidth
    * @param {integer} height Высота в пикселях
    * @since 5.2.0.1300
    * @todo: Реализовать до конца
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    */
    setHeight: function (height) {
      var me = this;
      me.height = height;
      if (me._jContent) {
        me._jContent.dialog("option", "height", height);
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Задает заголовок окна.
    *
    * @method WebAccess.components.dialogs.BaseDialog#setTitle
    * @param {string} title Заголовок окна
    * @since 5.0.0.5000
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    */
    setTitle: function (title) {
      this.title = title;
      if (this.isOpened()) $('#dialog_content_' + this.id).parents(".ui-dialog").find(".ui-dialog-title").html(title);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверяет, открыто ли диалоговое окно.
    *
    * @function WebAccess.components.dialogs.BaseDialog#isOpened
    * @since 5.0.0.5000
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    */
    isOpened: function () {
      return ($('#dialog_content_' + this.id).length) > 0;
    },

    /**
    * Очищает содержимое окна.
    *
    * @function WebAccess.components.dialogs.BaseDialog#clear
    * @since 5.0.0.7100
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    */
    clear: function () {
      this.setHtml('');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Устанавливает содержимое диалогового окна.
    *
    * @function WebAccess.components.dialogs.BaseDialog#setHtml
    * @param {string} html Содержимое окна – текст html-разметки
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    */
    setHtml: function (html) {
      this.html = html;
      if (this.isOpened()) $('#dialog_content_' + this.id).html(this.html);
      this._placeInCenter();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Установка сочетаний клавиш, для текущего окна.
    * @private
    */
    _setupKeyScope: function () {
      var me = this;

      for (var keyName in me.keyBindings) {
        key(keyName, me.keyScope, me.keyBindings[keyName]);
      }

      key.setScope(me.keyScope);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Делает кнопку доступной.
    *
    * @method WebAccess.components.dialogs.BaseDialog#enableButton
    * @param {string} buttonId ИД кнопки, например, "modal_ok_button","modal_cancel_button"
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    */
    enableButton: function (buttonId) {
      if (!!buttonId) {
        $("#" + buttonId + "_" + this.id).attr('disabled', false).removeClass("disabled");
        $("#" + buttonId).attr('disabled', false).removeClass("disabled");
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Делает кнопку недоступной.
    *
    * @method WebAccess.components.dialogs.BaseDialog#disableButton
    * @param {string} buttonId ИД кнопки, например, "modal_ok_button","modal_cancel_button"
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    */
    disableButton: function (buttonId) {
      if (!!buttonId) {
        $("#" + buttonId + "_" + this.id).attr('disabled', true).addClass("disabled");
        $("#" + buttonId).attr('disabled', true).addClass("disabled");
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Изменяет свойства кнопки с указанным ИД.
    *
    * @method WebAccess.components.dialogs.BaseDialog#changeButton
    * @param {string} buttonId ИД кнопки, например "modal_ok_button","modal_cancel_button"
    * @param {object} params Новые свойства кнопки
    */
    changeButton: function (buttonId, params) {
      var me = this;

      var button = _.findWhere(me.modalWindowButtons, { id: buttonId });
      if (button) {
        _.each(_.keys(params), function (key) {
          button[key] = params[key];
        });
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Перерисовывает кнопки в диалоге из dialog.modalWindowButtons.
    *
    * @method WebAccess.components.dialogs.BaseDialog#updateButtons
    */
    updateButtons: function () {
      var me = this;
      me._jDialog.dialog('option', 'buttons', me.modalWindowButtons);
    },

    /**
    * Добавляет иконку к кнопке.
    *
    * @method WebAccess.components.dialogs.BaseDialog#addButtonIcon
    * @param {string} buttonId ИД кнопки, например "modal_ok_button","modal_cancel_button"
    * @param {string} iconClass Класс иконки (jQuery UI)
    */
    addButtonIcon: function (buttonId, iconClass) {
      var me = this;
      me.changeButton(buttonId, { icons: { primary: iconClass, secondary: null } });
      me.updateButtons();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Удаляет иконку у указанной кнопки.
    *
    * @method WebAccess.components.dialogs.BaseDialog#removeButtonIcon
    * @param {string} buttonId ИД кнопки, например, "modal_ok_button","modal_cancel_button"
    */
    removeButtonIcon: function (buttonId) {
      var me = this;
      me.changeButton(buttonId, { icons: { primary: null, secondary: null } });
      me.updateButtons();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Переводит кнопку в состояние ожидания (со спиннером).
    *
    * @method WebAccess.components.dialogs.BaseDialog#enableButtonWaitState
    * @param {string} buttonId ИД кнопки, например, "modal_ok_button","modal_cancel_button"
    * @param {string} waitText Текст для отображения на кнопке
    */
    enableButtonWaitState: function (buttonId, waitText) {
      var me = this;
      var button = _.findWhere(me.modalWindowButtons, { id: buttonId });
      if (button) {
        button.originalText = button.text;
        if (waitText)
          button.text = waitText;
        me.addButtonIcon(buttonId, 'ui-wait-spinner');

        me.disableButton(buttonId);
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Возвращает кнопку в нормальное состояние.
    *
    * @method WebAccess.components.dialogs.BaseDialog#disableButtonWaitState
    * @param {string} buttonId ИД кнопки, например, "modal_ok_button","modal_cancel_button"
    */
    disableButtonWaitState: function (buttonId) {
      var me = this;
      var button = _.findWhere(me.modalWindowButtons, { id: buttonId });
      if (button) {
        if (button.orginalText)
          button.text = button.originalText;
        me.removeButtonIcon(buttonId);
        me.enableButton(buttonId);
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавляет иконку справки на форму диалогового окна.
    *
    * @method WebAccess.components.dialogs.BaseDialog#addHelpIcon
    * @param {boolean} isCustomDlg Признак прикладного диалога
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    * @since 5.0.0.7300
    */
    addHelpIcon: function (isCustomDlg) {
      let wnd = this._getDialogTitleBar(isCustomDlg);
      if (wnd && wnd.length > 0) {
        if (wnd.find('.DialogHelpIco').length === 0) {
          wnd.append('<a href="#" class="DialogHelpIco ui-dialog__help-button" onclick="return false;"><svg class="ui-dialog__help-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#help-16"></use></svg></a>');
        }
      }
      return this;
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает заголовок окна диалога.
    * @private
    */
    _getDialogTitleBar: function(isCustomDlg) {
      let wnd = this._jDialog;
      if (wnd && wnd.length > 0) {
        if (isCustomDlg !== true) {
          wnd = wnd.parent().find('.ui-dialog-titlebar');
        }
      }
      return wnd;
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показывает иконку справки на форме диалогового окна.
    *
    * @method WebAccess.components.dialogs.BaseDialog#showHelpIcon
    * @param {boolean} isCustomDlg Признак прикладного диалога
    * @param {string} contextId ИД текущего контекста для получения ссылки на внешнюю справку
    * @since 5.8.0.9008
    */
    showHelpIcon: function (isCustomDlg,contextId) {
      let wnd = this._getDialogTitleBar(isCustomDlg);
      let icon = wnd.find('.DialogHelpIco');
      if (!!window['g_ModalWindowExtHelpLinks'] && g_IsExtHelpAvailable) {
        // Сбрасываем click на иконку Справки и запрещаем дальнейшую инициализацию в Core
        icon.off('click').addClass('inited').attr('title', L('HELP'));

        const helpLinks = window['g_ModalWindowExtHelpLinks'][contextId];
        if (helpLinks) {
          let lastHelpLink;
          let menuItems = [];
          for (helpLink in helpLinks) {
            lastHelpLink = helpLink;
            let currentLink = helpLinks[helpLink];
            let click = ( (_currentLink) => {
              return () => { window.open(_currentLink); };
            })(currentLink);
            menuItems.push({
              text: helpLink,
              onClick: click,
            });
          };
          if (menuItems.length > 0) {
            menuItems[menuItems.length - 1].separator = true;
          }

          if (menuItems.length === 1) {
            icon.on('click', ()=> {
              window.open(lastHelpLink);
            });
          } else {
            let menu = new ContextMenu(menuItems);
            $(icon).contextMenu(menu, "click");
          }
        };
      }
      icon.show();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    onOK: function (callback) {
      this.ok = WA.TCD(callback);
      return this;
    },

    onCancel: function (callback) {
      this.cancel = WA.TCD(callback);
      return this;
    },

    /**
    * Показывает диалоговое окно.
    *
    * @function WebAccess.components.dialogs.BaseDialog#show
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    */
    show: function () {
      var me = this;

      //скрывать все календари
      $('.ui-datepicker').hide();

      if (me.isSingleme && $("div#dialog_content_" + me.id).length > 0) return me;

      var existingButtons = [];
      for (var i = 0; i < me.modalWindowButtons.length; i++) {
        existingButtons.push(me.modalWindowButtons[i].id);
        if (me.modalWindowButtons[i].closeDialog === undefined || !!me.modalWindowButtons[i].closeDialog) {
          me.modalWindowButtons[i].click = me.modalWindowButtons[i].click.override(function () {
            var res = this.superFunction();
            if (res === false) { return res; }
            $(this).dialog("close");
            $(this).remove();
            return res;
          });
          me.modalWindowButtons[i]['data-name'] = me.modalWindowButtons[i].id;
        }
      }

      if (me.isShowOkButton) {
        if (existingButtons.indexOf("modal_ok_button_" + me.id) === -1)
          me.modalWindowButtons.push({
            id: "modal_ok_button_" + me.id,
            text: me.okText,
            click: function () { if (me.ok(this) === false) { return; } $(this).dialog("close"); $(this).remove(); },
            'class': 'primary',
            'data-name': 'OkButton'
          });
      }
      if (me.isShowCancelButton) {
        if (existingButtons.indexOf("modal_cancel_button_" + me.id) === -1)
          me.modalWindowButtons.push({
            id: "modal_cancel_button_" + me.id,
            text: me.cancelText,
            click: function () { if (me.cancel(this) === false) { return; } $(this).dialog("close"); $(this).remove(); },
            'data-name': 'CancelButton'
          });
      }

      /**
       * При нажатии на OK вызовем соответствующее событие, для этого
       * задекорируем существующу функцию и добавим немного своей логики
       * @ignore
       */
      me.ok = me.ok.override(
        function () {
          me.fire("ok");
          return this.superFunction();
        }
      );

      if (me.cancel) {
        me.cancel = me.cancel.override(
        function () {
          me.fire("cancel");
          return this.superFunction();
        });
      }

      $("div#dialog_content_" + me.id).parent("div").remove();

      me._jDialog = $('<div>', { html: '<div id="dialog_content_' + me.id + '" class="dialog-content-container ' + (me.wordWrap ? +'word-wrap' : '') + '">' + me.html + '</div>' });

      var globalPrevBeforeUnloadFunc = null;
      var globalPrevFormVal = '';
      me._jContent = me._jDialog.dialog({
        zIndex: 1000,
        title: me.title,
        resizable: me.resizable,
        height: me.height,
        width: me.width,
        modal: me.modal,
        dialogClass: me.dialogClass,
        closeText: me.closeText,
        open: function () {
          // Сохраняем предыдущее состояние формы, что бы при закрытии диалога восстановить это значение.
          globalPrevFormVal = window['g_prevFormVal'];
          globalPrevBeforeUnloadFunc = window.onbeforeunload;

          if (me.height == 'auto') {
            if (me._jDialog.height() > $(window).height() * 0.8) {
              var optimalHeight = Math.round(0.8 * windowHeight());
              me._jDialog.dialog("option", "height", optimalHeight);
              me._isFitted = true;
            }
          }

          me.inlineHint = new WA.CMP.NTF.InlineHint({}, me.id);
          me._setupKeyScope();
          hideAllPopups();
          me.fire("show");
          me.fire(me['class'].EVENT.AFTER_OPEN, me);
          if (me.onOpen) me.onOpen();
          AdjustDialogIfIpad(me.width);
          var buttons = me._jDialog.next();
          InitHoverForButtons(buttons);
          me._jDialog.find('.ui-dialog-content').css('overflow', 'auto');
          me._jDialog.css("min-width", me.minWidth);
          me._placeInCenter();
          $(window).on("resizeEnd.BaseDialog", function () {
            me._placeInCenter();
          });
        },
        autoOpen: true,
        beforeClose: function (event) {
          if (me.fire(me['class'].EVENT.BEFORE_CLOSE, me) === false) return false;
          if (event.keyCode === $.ui.keyCode.ESCAPE) {
            if (me.closeOnEscape) {
              me.bind(me['class'].EVENT.AFTER_CLOSE, function (event) {
                // После закрытия по esc вызываем destroy, чтобы удалить диалог, а не просто скрыть
                me._jContent.dialog('destroy');
              });
            }
            return (me.fire(me['class'].EVENT.BEFORE_CLOSE_BY_ESCAPE, me) !== false);
          }
        },
        close: function () {
          $(window).off("resizeEnd.BaseDialog");
          if (me.onClose) me.onClose();
          //clearAllModalDivs();
          hideAllPopups();
          me.fire(me['class'].EVENT.AFTER_CLOSE, me);
          key.setScope('common');
          // Восстанавливаем предыдущее состояние формы, если еще надо.
          if (window.onbeforeunload) {
            window['g_prevFormVal'] = globalPrevFormVal;
            window.onbeforeunload = globalPrevBeforeUnloadFunc;
          }
        },
        buttons: me.modalWindowButtons,
        closeOnEscape: me.closeOnEscape
      });

      me.addHelpIcon();
      me._setStatisticsClasses();

      me.fire('OnAfterOpen');

      me._jContent.parent().find(".ui-dialog-titlebar-close").off('click').on('click', function () {
        if (me.fire(me['class'].EVENT.BEFORE_CLOSE_BY_CROSS, me) !== false) {
          me.close();
        };
      });

      return me;
    },

    // Смещение диалога в центр экрана.
    _placeInCenter: function () {
      var jDialog = $('#dialog_content_' + this.id).parent();
      jDialog.parent().position({
        my: "center center",
        at: "center center",
        of: window
      });
    },

    /**
    * Добавление классов для клиентской статистики.
    * @function WebAccess.components.dialogs.BaseDialog#close
    * @return {WebAccess.components.dialogs.BaseDialog}
    * @private
    */
    _setStatisticsClasses: function () {
      // Для статистики.
      var jModalWindowContainer = this._jContent.parents('.ui-dialog').addClass("stat_ModalWindow_" + this.className).attr("data-stataction", 'ModalWindow');
      jModalWindowContainer.find('.ui-dialog-titlebar').addClass('stat_Title');
      jModalWindowContainer.find('.ui-dialog-titlebar-close').attr('data-name', 'CloseIcon');
      jModalWindowContainer.find('.DialogHelpIco').attr('data-name', 'HelpIcon');
      jModalWindowContainer.find('.ui-dialog-content').addClass('stat_Content');
      jModalWindowContainer.find('.ui-dialog-buttonpane').addClass('stat_Buttons');
    },

    /**
    * Закрывает диалоговое окно.
    *
    * @function WebAccess.components.dialogs.BaseDialog#close
    * @return {WebAccess.components.dialogs.BaseDialog} Объект типа BaseDialog.
    */
    close: function () {
      if (!!this._jContent) {
        //просто close не удаляет верстку, а только прячет
        //поэтому вызываем destroy
        //но close тоже нужен, иначе не отрабатывают события
        this._jContent.dialog('close');
        this._jContent.dialog('destroy');
      }
      return this;
    }

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  },
  {
    EVENT: {

      /**
      * Срабатывает перед закрытием модального окна.
      * Можно предотвратить закрытие диалога, вернув false в обработчике события.
      * @event WebAccess.components.dialogs.BaseDialog.EVENT.BEFORE_CLOSE
      * @param {WebAccess.components.dialogs.BaseDialog} dialog экземпляр диалога
      * @since 5.2.0.1600
      */
      BEFORE_CLOSE: 'beforeClose',

      /**
      * Срабатывает перед закрытием модального окна от нажатия кнопки Escape.
      * Можно предотвратить закрытие диалога, вернув false в обработчике события.
      * @event WebAccess.components.dialogs.BaseDialog.EVENT.BEFORE_CLOSE_BY_ESCAPE
      * @param {WebAccess.components.dialogs.BaseDialog} dialog экземпляр диалога
      * @since 5.2.0.1600
      */
      BEFORE_CLOSE_BY_ESCAPE: 'escapeClose',

      /**
      * Срабатывает перед закрытием модального окна от нажатия на крестик в заголовке окна.
      * Можно предотвратить закрытие диалога, вернув false в обработчике события.
      * @event WebAccess.components.dialogs.BaseDialog.EVENT.BEFORE_CLOSE_BY_CROSS
      * @param {WebAccess.components.dialogs.BaseDialog} dialog экземпляр диалога
      * @since 5.2.0.1600
      */
      BEFORE_CLOSE_BY_CROSS: 'crossClose',

      /**
      * Срабатывает после закрытия диалогового окна.
      * @event WebAccess.components.dialogs.BaseDialog.EVENT.AFTER_CLOSE
      * @param {WebAccess.components.dialogs.BaseDialog} dialog экземпляр диалога
      * @since 5.2.0.1600
      */

      AFTER_CLOSE: 'close',

      /**
      * Срабатывает перед закрытием модального окна.
      * Можно предотвратить закрытие диалога, вернув false в обработчике события.
      * @event WebAccess.components.dialogs.BaseDialog.EVENT.AFTER_OPEN
      * @param {WebAccess.components.dialogs.BaseDialog} dialog экземпляр диалога
      * @since 5.2.0.1600
      */
      AFTER_OPEN: 'open',

      /**
      * Срабатывает после закрытия модального окна по кнопке ОК.
      * @event WebAccess.components.dialogs.BaseDialog.EVENT.AFTER_CLOSE_BY_OK
      * @param {WebAccess.components.dialogs.BaseDialog} dialog экземпляр диалога
      * @since 5.2.0.1600
      */
      AFTER_CLOSE_BY_OK: 'ok',

      /**
      * Срабатывает после закрытия модального окна по кнопке Отмена.
      * @event WebAccess.components.dialogs.BaseDialog.EVENT.AFTER_CLOSE_BY_OK
      * @param {WebAccess.components.dialogs.BaseDialog} dialog экземпляр диалога
      * @since 5.2.0.1934
      */
      AFTER_CLOSE_BY_CANCEL: 'cancel'
    }
  });

  global.BaseDialog = BaseDialog;
})(window.WebAccess.components.dialogs);
